import { Link } from 'react-router-dom';
import { useLanguage } from '../utils/i18n';
import Logo from '../components/Logo';
import LanguageToggle from '../components/LanguageToggle';
import { useNotification } from '../utils/NotificationContext';

export default function Contact() {
    const { t } = useLanguage();
    const { showNotification } = useNotification();
    const contactEmail = 'support@wafiyo.com';

    function copyToClipboard() {
        navigator.clipboard.writeText(contactEmail);
        showNotification(t('email_copied'), 'success');
    }

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
            {/* Navbar */}
            <nav className="navbar">
                <Link to="/" className="navbar-brand">
                    <Logo size={24} />
                    <span>Wafiyo</span>
                </Link>
                <LanguageToggle />
            </nav>

            <div className="container" style={{ maxWidth: 600, paddingTop: 80, paddingBottom: 80 }}>
                <div className="glass-card" style={{ padding: '60px 32px', textAlign: 'center' }}>
                    <div style={{ fontSize: 48, marginBottom: 24 }}>📧</div>
                    <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 16 }}>{t('contact_title')}</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 16, marginBottom: 32, lineHeight: 1.6 }}>
                        {t('contact_message')}
                    </p>

                    <a
                        href={`mailto:${contactEmail}`}
                        className="hover-lift"
                        style={{
                            background: 'rgba(59, 130, 246, 0.1)',
                            border: '1px solid rgba(59, 130, 246, 0.2)',
                            borderRadius: 16,
                            padding: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 12,
                            cursor: 'pointer',
                            marginBottom: 20,
                            width: '100%',
                            justifyContent: 'center',
                            textDecoration: 'none'
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                        </svg>
                        <span style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}>{t('contact_via_email')}</span>
                    </a>

                    <a
                        href="https://www.instagram.com/wafiyo.co"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover-lift"
                        style={{
                            background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                            borderRadius: 16,
                            padding: '20px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 12,
                            cursor: 'pointer',
                            marginBottom: 40,
                            width: '100%',
                            justifyContent: 'center',
                            textDecoration: 'none'
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                        </svg>
                        <span style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}>{t('follow_us_instagram')}</span>
                    </a>

                    <div>
                        <Link to="/" className="btn btn-outline btn-sm glass-btn">{t('back_to_home')}</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
